import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ListChecks } from "lucide-react";
import { useDocumentTitle } from "usehooks-ts";

export const Route = createFileRoute("/lists")({
  component: ListsLayout,
});

function ListsLayout() {
  const { user } = Route.useRouteContext();
  useDocumentTitle("Lists | Notebook");

  if (!user) {
    return (
      <>
        <header className="flex h-14 md:h-16 shrink-0 items-center gap-3 px-4 md:px-6">
          <div className="flex-1">
            <h1 className="text-lg md:text-xl font-semibold tracking-tight text-foreground flex items-center gap-2">
              <ListChecks className="h-5 w-5" />
              Lists
            </h1>
          </div>
        </header>
        <div className="flex-1 flex items-center justify-center p-6">
          <div className="text-center space-y-4">
            <ListChecks className="h-16 w-16 text-muted-foreground mx-auto" />
            <div className="space-y-2">
              <h2 className="text-2xl font-semibold text-foreground">Lists</h2>
              <p className="text-muted-foreground">
                Sign in to view your lists
              </p>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      <header className="flex h-14 md:h-16 shrink-0 items-center gap-3 px-4 md:px-6 border-b">
        <div className="flex-1">
          <h1 className="text-lg md:text-xl font-semibold tracking-tight text-foreground flex items-center gap-2">
            <ListChecks className="h-5 w-5" />
            Lists
          </h1>
        </div>
      </header>

      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
